import { keepTogether, MISSING_NUMBER, numberLocale } from './locale';

const formatters = new Map<string, Intl.NumberFormat>();

function formatter(locale: string): Intl.NumberFormat {
  let cached = formatters.get(locale);
  if (!cached) {
    cached = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
    formatters.set(locale, cached);
  }
  return cached;
}

/** Kilometres as a plain number in the UI language: "45.120" (de), "45,120" (en). */
export function formatKmNumber(km?: number | null, lang?: string): string {
  if (km == null) return MISSING_NUMBER;
  return formatter(numberLocale(lang)).format(km);
}

/** Kilometres with unit, never wrapping apart: "45.120 km". A missing value renders as "—". */
export function formatKm(km?: number | null, lang?: string): string {
  if (km == null) return MISSING_NUMBER;
  return keepTogether(`${formatKmNumber(km, lang)} km`);
}
